import { padStart } from 'lodash'

export function capitalize(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function truncate(string: string = '', length: number = 30, omission: string = '...'): string {
  const omissionLength = omission.length
  if (length < omissionLength) {
    return omission.slice(0, length)
  } else {
    return string.length > length ? `${string.slice(0, length - omissionLength).trim()}${omission}` : string
  }
}

// turns number 1 into string '01'
export function pad(input: number): string {
  return zerofill(input, 2)
}

// turns string "01" in string "1"
export function unpad(string: string): string {
  if (string[0] === '0') {
    return string[1]
  }
  return string
}

// strips non-numeric chars from a string
export function stripNonNumeric(str: string): string {
  return str.replace(/\D/g, '')
}

export function containsNullOrUndefined(str: string): boolean {
  return str.includes('null') || str.includes('undefined')
}

// adds leading zeros to a number
export function zerofill(input: number, minLength: number = 2): string {
  if (input === null || input === undefined) {
    return padStart('', minLength, '0')
  } else {
    return padStart(input.toString(), minLength, '0')
  }
}

// turns 'TextField' into 'text-field'
export function camelToKebabCase(input: string): string {
  return input.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
}
